// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__279n2","mobileMenu":"Footer_mobileMenu__X5Btt","footerLogo":"Footer_footerLogo__2KGvE","footerContainer":"Footer_footerContainer__3wt0Z"};